const getEnv = (key: string): string | undefined => {
  if (typeof window !== 'undefined') {
    return (window as any).env[key];
  }
  return process.env[key];
};

// 배포 환경 정보
const KC_PARTITION = getEnv('KC_PARTITION'); // 배포된 클러스터
const KC_REGION = getEnv('KC_REGION'); // 배포된 리전
const KC_ENV = getEnv('KC_ENV'); // 프로파일(stage/standby/prod)
// 서비스 정보
const KC_REMOTE_ENDPOINT_PRIMARY = getEnv('KC_REMOTE_ENDPOINT_PRIMARY');
const KC_REMOTE_ENDPOINT_STANDBY = getEnv('KC_REMOTE_ENDPOINT_STANDBY');
const KC_DEV_REMOTE_TARGET_SERVICE = getEnv('KC_DEV_REMOTE_TARGET_SERVICE');
const KC_DEV_REMOTE_URL = getEnv('KC_DEV_REMOTE_URL');
const KC_IAM_SSR_ENDPOINT = getEnv('KC_IAM_SSR_ENDPOINT');
const KC_IAM_ENDPOINT = getEnv('KC_IAM_ENDPOINT');
const KC_META_ENDPOINT = getEnv('KC_META_ENDPOINT');
const KC_TRANSLATION_ENDPOINT = getEnv('KC_TRANSLATION_ENDPOINT');
const KC_TRANSLATION_FALLBACK_ENDPOINT = getEnv('KC_TRANSLATION_FALLBACK_ENDPOINT');
const KC_SENTRY_DSN = getEnv('KC_SENTRY_DSN');
const KC_RELEASE_TAG = getEnv('KC_RELEASE_TAG');
const KC_GTM_ID = getEnv('KC_GTM_ID');
const KC_MONACO_EDITOR_CDN = getEnv('KC_MONACO_EDITOR_CDN');
const KC_STREAM_ENDPOINT = getEnv('KC_STREAM_ENDPOINT');
// account용
const KC_HTTP_BASIC_AUTH = getEnv('KC_HTTP_BASIC_AUTH');
const KC_PORTAL_URL = getEnv('KC_PORTAL_URL');
const KC_PORTAL_API_ENDPOINT = getEnv('KC_PORTAL_API_ENDPOINT');
const KC_SIGNUP_API_ENDPOINT = getEnv('KC_SIGNUP_API_ENDPOINT');
const KC_DOCS_URL = getEnv('KC_DOCS_URL');
// status dashboard 용
const KC_FALLBACK_STATUS_ENDPOINT = getEnv('KC_FALLBACK_STATUS_ENDPOINT');
const KC_FALLBACK_STATUS_INTERNAL_ENDPOINT = getEnv('KC_FALLBACK_STATUS_INTERNAL_ENDPOINT');
const KC_DEFAULT_STATUS_REGION = getEnv('KC_DEFAULT_STATUS_REGION');

// 서비스 공통 BD 권유 상단 배너 > 모달 > 가이드 링크
const KC_NEW_CONSOLE_GUIDE_LINK = getEnv('KC_NEW_CONSOLE_GUIDE_LINK'); // 새 콘솔 가이드 링크 URL
// 서비스 공통 BD 권유 상단 배너 > 표시 여부
const KC_SHOW_CONSOLE_VERSION_BANNER = getEnv('KC_SHOW_CONSOLE_VERSION_BANNER');
// idle boundary 비활성화 여부 ('true'인 경우 idle 로직을 우회)
const DISABLE_IDLE_BOUNDARY = getEnv('DISABLE_IDLE_BOUNDARY');
// 403 Forbidden 상태 코드 에러 화면 가이드 링크
const KC_FORBIDDEN_GUIDE_LINK = getEnv('KC_FORBIDDEN_GUIDE_LINK');
// LOGGING 관련 변수
const KC_PERFORMANCE_LOGGING = getEnv('KC_PERFORMANCE_LOGGING');

const env = {
  KC_REMOTE_ENDPOINT_PRIMARY,
  KC_REMOTE_ENDPOINT_STANDBY,
  KC_DEV_REMOTE_TARGET_SERVICE,
  KC_DEV_REMOTE_URL,
  KC_IAM_SSR_ENDPOINT,
  KC_IAM_ENDPOINT,
  KC_META_ENDPOINT,
  KC_TRANSLATION_ENDPOINT,
  KC_TRANSLATION_FALLBACK_ENDPOINT,
  KC_SENTRY_DSN,
  KC_RELEASE_TAG,
  KC_GTM_ID,
  KC_MONACO_EDITOR_CDN,
  KC_STREAM_ENDPOINT,
  KC_HTTP_BASIC_AUTH,
  KC_PORTAL_URL,
  KC_PORTAL_API_ENDPOINT,
  KC_SIGNUP_API_ENDPOINT,
  KC_DOCS_URL,
  KC_NEW_CONSOLE_GUIDE_LINK,
  KC_SHOW_CONSOLE_VERSION_BANNER,
  KC_ENV,
  KC_PARTITION,
  KC_REGION,
  KC_FALLBACK_STATUS_ENDPOINT,
  KC_FALLBACK_STATUS_INTERNAL_ENDPOINT,
  KC_DEFAULT_STATUS_REGION,
  DISABLE_IDLE_BOUNDARY,
  KC_FORBIDDEN_GUIDE_LINK,
  KC_PERFORMANCE_LOGGING,
} as const;

export default env;
